import * as React from "react";
import * as styles from './Spinner.module.less';

export interface ISpinnerProps {
    loading?: boolean;
    speedMultiplier?: number;
    majorColor?: string;
    minorColor?: string;
    size?: number;
    thickness?: number;
}

export const Spinner = ({
    loading = true,
    speedMultiplier = 1,
    majorColor = "#ccc",
    minorColor = "#333333",
    size = 35,
    thickness = 3,
}: ISpinnerProps) => {
    const style: React.CSSProperties = {
        width: `${size}px`,
        height: `${size}px`,
        border: `${thickness}px solid`,
        borderTopColor: majorColor,
        borderLeftColor: majorColor,
        borderRightColor: majorColor,
        borderBottomColor: minorColor,
        animationDuration: `${0.75 / speedMultiplier}s`,
    };

    if (!loading) {
        return;
    }

    return <span className={styles.spinner} style={style} />;
}
